export const versionService = {
  async checkForUpdates(): Promise<boolean> {
    const response = await fetch('/version.txt?t=' + new Date().getTime());
    const newVersion = await response.text();
    return newVersion.trim() !== (import.meta.env.VITE_COMMIT_SHA ?? '');
  },
};
